import React, { ReactNode } from 'react'
import Tooltip from '@mui/material/Tooltip'

interface HoverTooltipProps {
  children: ReactNode
  message: string
}

const HoverTooltip: React.FC<HoverTooltipProps> = ({ children, message }) => {
  return (
    <Tooltip
      title={message}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fff',
            color: '#000',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            fontSize: '0.95rem',
            borderRadius: '6px',
            border: '1px solid #ddd',
          },
        },
        arrow: {
          sx: {
            color: '#fff',
          },
        },
      }}
      placement="top"
    >
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  )
}

export default HoverTooltip
